export default __webpack_public_path__ + "static/media/exam-topic-remark-active-icon.9e89a7d8.svg";